import { Injector } from '@angular/core';
import { draggableNodeStopEvent } from '@examdojo/core/tiptap';
import { mergeAttributes, Node } from '@tiptap/core';
import { AngularNodeViewRenderer } from 'ngx-tiptap';
import { WidgetNodeComponent } from './widget.component';
import { DEFAULT_WIDGET_PROPS } from './widget.model';

const widgetClassName = 'widget';

export const WidgetExtension = (injector: Injector) => {
  return Node.create({
    name: 'widget',
    group: 'block',
    atom: true,
    selectable: true,
    // draggable: true, // Removed to prevent dragging from anywhere in the component

    addAttributes() {
      return {
        title: {
          default: null,
        },
        config: {
          default: DEFAULT_WIDGET_PROPS.config,
          // Serialize config as JSON string for HTML (copy/paste)
          renderHTML: (attributes) => {
            const config = attributes['config'];
            if (!config) {
              return {};
            }
            return {
              'data-config': JSON.stringify(config),
            };
          },
          // Parse config from JSON string when pasting
          parseHTML: (element) => {
            const configStr = element.getAttribute('data-config');
            if (!configStr) {
              return DEFAULT_WIDGET_PROPS.config;
            }
            try {
              return JSON.parse(configStr);
            } catch {
              return DEFAULT_WIDGET_PROPS.config;
            }
          },
        },
        class: {
          renderHTML: (attributes) => {
            const otherClasses = ((attributes['class'] ?? '') as string)
              .split(' ')
              .filter((c) => c !== widgetClassName);
            return { class: `${widgetClassName} ${otherClasses.join(' ')}` };
          },
        },
      };
    },

    parseHTML() {
      return [
        {
          tag: `div.${widgetClassName}`,
        },
      ];
    },

    renderHTML({ HTMLAttributes }) {
      return ['div', mergeAttributes({ class: widgetClassName }, HTMLAttributes)];
    },

    addNodeView() {
      return AngularNodeViewRenderer(WidgetNodeComponent, {
        injector,
        stopEvent: draggableNodeStopEvent,
      });
    },
  });
};
